import MuiTooltip from '@mui/material/Tooltip';

import { getTypographyStyles, styled } from 'helpers';

import { Props } from './types';

// Tooltips are wrapped in a Popper, which is wrapped in a Portal component,
// which is rendered outside the DOM hierarchy. The class name of the Popper
// needs to be passed to the Tooltip, which is why this TooltipWithClass
// is necessary.
// https://mui.com/guides/interoperability/#portals
const TooltipWithClass = ({ className, ...props }: Props) => (
  <MuiTooltip {...props} classes={{ popper: className }} />
);

/* eslint-disable sonarjs/no-duplicate-string */
export const Tooltip = styled(TooltipWithClass)<Props>`
  .MuiTooltip-arrow {
    color ${({ theme }) => theme.palette.secondary.contrastText};
  }
  
  .MuiTooltip-tooltip {
    ${({ theme }) => getTypographyStyles('caption', theme)};
    background-color: ${({ theme }) => theme.palette.secondary.contrastText};
    color: ${({ theme }) => theme.palette.common.white};
    font-family: ${({ theme }) => theme.typography.fontFamily};
    margin: 0;
    max-width: 308px;
    padding: 0.5rem 1rem;
  }
    
  .MuiTooltip-tooltipPlacementLeft,
  .MuiTooltip-tooltipPlacementRight {
    margin-left: 0.5rem !important;
    margin-right: 0.5rem !important;
      
    .MuiTooltip-arrow {
      // fix for Firefox when arrow is on left or right,
      // prevents white line between arrow and tooltip body
      overflow: inherit;
    }
  }
    
  .MuiTooltip-tooltipPlacementBottom,
  .MuiTooltip-tooltipPlacementTop {
      margin-top: 0.5rem !important;
      margin-bottom: 0.5rem !important;
  }
`;
Tooltip.displayName = 'Tooltip';

export default Tooltip;
